import { render, staticRenderFns } from "./ViaCepSearch.vue?vue&type=template&id=21f8950e&scoped=true"
import script from "./ViaCepSearch.vue?vue&type=script&lang=js"
export * from "./ViaCepSearch.vue?vue&type=script&lang=js"
import style0 from "./ViaCepSearch.vue?vue&type=style&index=0&id=21f8950e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8950e",
  null
  
)

export default component.exports